import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f1641518&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f1641518&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1641518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1641518')) {
      api.createRecord('f1641518', component.options)
    } else {
      api.reload('f1641518', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f1641518&scoped=true", function () {
      api.rerender('f1641518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuTemplateManage/index.vue"
export default component.exports